export default "__VITE_ASSET__b349c39e__"